import { ASSET_REV } from "../version";

export function withCacheBuster(url) {
  if (!url) return url;
  const str = String(url);
  const sep = str.includes("?") ? "&" : "?";
  return `${str}${sep}v=${encodeURIComponent(ASSET_REV || "dev")}`;
}

